module.exports = __webpack_public_path__ + "static/media/deal-bg.4dd14f3d.png";